import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonApiService } from 'src/helper/common-api.service';
import { CommonHelper } from 'src/helper/common-helper';

@Component({
  selector: 'app-get-involved',
  templateUrl: './get-involved.component.html',
  styleUrls: ['./get-involved.component.css']
})
export class GetInvolvedComponent implements OnInit {

  eventForm!:FormGroup;
  submitted = false;

  getInvolvedHeading = '';
  getInvolvedYoutubeId = '';
  getInvolvedContent = '';

  constructor(   public sanitizer: DomSanitizer, private commonApiService: CommonApiService,private CommonHelper:CommonHelper) { }

  ngOnInit(): void {
    this.loadForm({});
    this.setCommonData()

    this.CommonHelper.retrieveMappedCommonObjectObject().subscribe((t) =>{
     this.setCommonData()
    })
  }

  setCommonData()
  {
    this.getInvolvedHeading = CommonHelper.CommonDetails.getInvolvedHeading;
    this.getInvolvedYoutubeId = CommonHelper.CommonDetails.getInvolvedYoutubeId;
    this.getInvolvedContent = CommonHelper.CommonDetails.getInvolvedContent;
  }

  loadForm(t:any) {
    this.eventForm = new FormGroup({
      name: new FormControl(t?.name, [Validators.required]),
      email: new FormControl(t?.email, [Validators.required, Validators.pattern(`[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}`)]),
      phone: new FormControl(t?.phone, [Validators.required]),
      message: new FormControl(t?.message, [Validators.required]),
    });
  }

  handleConnect() {
    if(this.eventForm.valid) {
      this.commonApiService.getPromiseResponse({
        apiName: '/api/contact', methodType: 'post', parameterObject: this.eventForm.value
      }).then((result: any) => {
        this.submitted = true;
        this.eventForm.reset()
      }).catch((err: any) => {
      })
    }else{
      this.eventForm.markAllAsTouched()
    }
  }


  isControlValid(controlName: string): boolean {
    const control = this.eventForm.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.eventForm.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation: any, controlName: string | number): boolean {
    const control = this.eventForm.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName: string | number): boolean {
    const control = this.eventForm.controls[controlName];
    return control.dirty || control.touched;
  }

  securityByPass(url: any){
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
